import { render } from "./PagoProveedor.vue?vue&type=template&id=632f7c4c"
import script from "./PagoProveedor.vue?vue&type=script&lang=js"
export * from "./PagoProveedor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__